import moment from "moment";
import i18n from "@/i18n/config";
/**
 * 获取当前UTC日期时间
 *
 * @returns
 */
export const getCurrentUtcDatetime = () => {
	return moment().utc().format("YYYY-MM-DD HH:mm:ss.") + moment().millisecond();
};

/**
 * 获取当前UTC日期时间+1天的时间
 *
 * @returns
 */
export const getCurrentUtcNextDayDatetime = () => {
	return moment().utc().add(1, "day").format("YYYY-MM-DD");
};

/**
 * 获取当前UTC时间
 */
export function getCurrentTime() {
	return moment().utc().format("YYYY-MM-DD HH:mm:ss").toString();
}

/**
 * 格式化最近联系人时间
 *
 * @param {string} date
 */
export function formatChatDate(date) {
	const utcOffset = (new Date().getTimezoneOffset() / 60) * -1;

	const inputDate = moment(date + "+00:00")
		.utc()
		.utcOffset(utcOffset);

	const currentDate = moment().utc().utcOffset(utcOffset);

	if (inputDate.format("YYYY-MM-DD") == currentDate.format("YYYY-MM-DD")) {
		return inputDate.format("HH:mm");
	} else {
		return inputDate.format("YY-MM-DD");
	}
}

/**
 * 格式化聊天时间
 *
 * @param {string} date
 */
export function formatTalkDate(date) {
	const utcOffset = (new Date().getTimezoneOffset() / 60) * -1;

	const inputDate = moment(date + "+00:00")
		.utc()
		.utcOffset(utcOffset);

	const currentDate = moment().utc().utcOffset(utcOffset);

	if (inputDate.format("YYYY-MM-DD") == currentDate.format("YYYY-MM-DD")) {
		return i18n.t("dateJS.today") + inputDate.format("HH:mm");
	} else {
		return inputDate.format("YY-MM-DD HH:mm");
	}
}

/**
 * 计算过了几分钟
 *
 * @param {string} date
 */
export function diffByNow(date) {
	const offset = (new Date().getTimezoneOffset() / 60) * -1;

	const inputDate = moment(date + "+00:00")
		.utc()
		.utcOffset(offset);

	const currentDate = moment().utc().utcOffset(offset);

	return currentDate.diff(inputDate, "minutes");
}

/**
 * date1时间是否在date2之前
 *
 * @param {string} date1
 * @param {string} date2
 */
export function isBefore(date1, date2) {
	const date = moment(date1).format("YYYY-MM-DD HH:mm:ss");

	if (date == date2) return true;

	return moment(date).isBefore(date2);
}

export function stringToStamp(dateString) {
	return Math.floor(moment(dateString).valueOf() / 1000);
}

/**
 * UTC 时间转为本地时间
 *
 * @param {string} utcString - UTC 时间字符串，如 "2025-09-03 01:25:08"
 * @param {string} format - 输出格式（默认 "YYYY-MM-DD HH:mm:ss"）
 * @returns {string} 本地时区的时间字符串
 */
export function formatUtcToLocal(utcString, format = "YYYY-MM-DD HH:mm:ss") {
	if (!utcString) return "";

	const offset = moment().utcOffset() / 60;

	return moment(utcString + "+00:00")
		.utc()
		.utcOffset(offset)
		.format(format);
}
